export default __webpack_public_path__ + "static/O0186-424e727679c505c75b525141b1e43327.png";